// import qs from 'qs'
import request from '../utils/request'
import { commonConfig } from '../utils/config'
const { apiHetaoDomain } = commonConfig

// 获取团队科目
export function getSubjects() {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/team/subjects`)
}

// 获取团队科目
export function getSubjectstree(teamCodeList) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/team/subjects?teamCodeList=${teamCodeList}`)
}
